import type { Catalog } from './en';
import { idBackoffice } from './id/backoffice';
import { idCore } from './id/core';
import { idDapur } from './id/dapur';
import { idKasir } from './id/kasir';
import { idMenu } from './id/menu';
import { idOrder } from './id/order';
import { idPelayan } from './id/pelayan';
import { idStok } from './id/stok';
import { idStokInsights } from './id/stok-insights';
import { idRecipes } from './id/recipes';
import { idStokTransfers } from './id/stok-transfers';
import { idBoApPayments } from './id/bo-ap-payments';
import { idBoApInvoices } from './id/bo-ap-invoices';
import { idBoBudgets } from './id/bo-budgets';
import { idBoApprovals } from './id/bo-approvals';
import { idStokRequests } from './id/stok-requests';
import { idApprovals } from './id/approvals';
import { idStokCounts } from './id/stok-counts';
import { idStokLots } from './id/stok-lots';
import { idStokProcurement } from './id/stok-procurement';
import { idStokWaste } from './id/stok-waste';
import { idAccount } from './id/account';
import { idBillingSaas } from './id/billing-saas';
import { idBranding } from './id/branding';
import { idPlatform } from './id/platform';
import { idDataLifecycle } from './id/data-lifecycle';
import { idGudang } from './id/gudang';

/** Bahasa Indonesia catalog (the default UI language). Each area file is typed against its
 *  English counterpart, so a missing or extra key fails typecheck. */
export const id: Catalog = {
  ...idCore,
  ...idOrder,
  ...idKasir,
  ...idDapur,
  ...idPelayan,
  ...idBackoffice,
  ...idMenu,
  ...idStok,
  ...idStokProcurement,
  ...idStokLots,
  ...idStokWaste,
  ...idBranding,
  ...idStokCounts,
  ...idApprovals,
  ...idStokRequests,
  ...idBoApprovals,
  ...idBoBudgets,
  ...idStokInsights,
  ...idRecipes,
  ...idStokTransfers,
  ...idBoApPayments,
  ...idBoApInvoices,
  ...idAccount,
  ...idBillingSaas,
  ...idPlatform,
  ...idDataLifecycle,
  ...idGudang,
};
